import type { SVGProps } from 'react';

export function BriefcaseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 2a3 3 0 0 1 3 3v1h3a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h3V5a3 3 0 0 1 3-3zm-4 2a1 1 0 0 0-1 1v1h6V5a1 1 0 0 0-1-1z" />
    </svg>
  );
}
